import { useEffect, useState } from 'react'
import { ExpirationPasswordModal } from './ExpirationPasswordModal'
import { useAuthentication } from '@authentication/context'
import { useAuthenticatedUser } from '@authentication/queries'
import { getNumberOfDaysUntilExpiration } from '@authentication/utils'

const NUMBER_OF_DAYS_UNTIL_EXPIRATION =
  import.meta.env.VITE_NUMBER_OF_DAYS_UNTIL_EXPIRATION || 20

const MIN_DAYS_TO_EXPIRATION = import.meta.env.VITE_MIN_DAYS_TO_EXPIRATION || 2

export function PasswordExpiration() {
  const { data: user, isLoading, isSuccess } = useAuthenticatedUser()

  const { changePassword } = useAuthentication()
  const [openExpirationModal, setOpenExpirationModal] = useState(false)

  const expirationDate =
    user && user.password_expires_at && new Date(user?.password_expires_at)
  
  const daysUntilExpiration = expirationDate
    ? getNumberOfDaysUntilExpiration(expirationDate)
    : undefined
    
  const isAboutToExpire =
    Number(daysUntilExpiration) < NUMBER_OF_DAYS_UNTIL_EXPIRATION
  const isLessThanOneDay = Number(daysUntilExpiration) < MIN_DAYS_TO_EXPIRATION


  useEffect(() => {
    setTimeout(() => {
      if (isAboutToExpire && user?.password_expires_at) {
        setOpenExpirationModal(true)
      }
    }, 1000)
  }, [isAboutToExpire, user])

  function handleChangePassword() {
    setOpenExpirationModal(false)
    changePassword()
  }

  if (isLoading || !isSuccess) {
    return null
  }

  if (!user?.password_expires_at || !isAboutToExpire) {
    return null
  }

  return (
    <ExpirationPasswordModal
      open={openExpirationModal}
      isLessThanOneDay={isLessThanOneDay}
      daysUntilExpiration={daysUntilExpiration}
      onCancel={() => setOpenExpirationModal(false)}
      onOk={handleChangePassword}
    />
  )
}
